import { render, staticRenderFns } from "./newasset.vue?vue&type=template&id=0449b190&scoped=true"
import script from "./newasset.vue?vue&type=script&lang=js"
export * from "./newasset.vue?vue&type=script&lang=js"
import style0 from "./newasset.vue?vue&type=style&index=0&id=0449b190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0449b190",
  null
  
)

export default component.exports